<template>
  <div class="containe">
    <div class="about">
      <h3 class="ab-title"
          id="about">关于我们</h3>
      <div class="ab-text">爱医博通是一家致力于为医生和患者提供人工智能解决方案的高科技企业。我们利用自然语言处理（NLP）等人工智能技术将海量中外循证医学信息和真实病历进行挖掘、解析和融合，通过机器学习形成不断进化和具有推理能力的知识图谱，并以此为基础，针对不同级别医生和患者的多种使用场景，开发灵活的临床决策支持系统（Clinical Decision Support
        System，CDSS）应用方案。</div>
    </div>
    <div class="imgs">
      <div class="img marg">
        <div class="icon">
          <img class="md-icon"
               src="../assets/tigao.png">
        </div>
        <p class="margin">医院全科CDSS系统帮助医生更快、更准确进行诊断、治疗，提高医院信息系统标准化和智能化水平</p>
      </div>
      <div class="img marg">
        <div class="icon">
          <img class="md-icon"
               src="../assets/keshi.png">
        </div>
        <p class="margin">专科/单病种CDSS系统，帮助医院进行重点科室建设，提升专家医疗水平和市场竞争力</p>
      </div>
      <div class="img marg">
        <div class="icon">
          <img class="md-icon"
               src="../assets/gongju.png">
        </div>
        <p class="margin">eRWS科研辅助系统及工具，将全结构化的医疗信息用于真实世界研究，助力医生、药企、CRO以更高的效率收集管理及分析临床数据</p>
      </div>
      <div class="img marg">
        <div class="icon">
          <img class="md-icon"
               src="../assets/dianzibingli-3.png">
        </div>
        <p class="margin">集成CDSS技术的电子病历（EMR）平台为基层医生和患者提供智能问诊、导诊、健康档案、慢病管理、患教信息精准查询和推荐</p>
      </div>
    </div>
    <img class="bacimg"
         src="../assets/pg1.png">
    <div class="about"
         id="tech">
      <h3 class="ab-title">技术介绍</h3>
      <div class="ab-text">我们专注于人工智能技术在医疗行业的应用，主要是基于自然语言处理技术，通过深度学习方法+规则相结合的方式，从大量的书籍文献、病历、诊疗指南等文字资料中提取医学相关知识，形成医学领域知识图谱，以医学领域知识图谱为支撑，开发了全科CDSS，专科/单病种CDSS，eRWS产品。</div>
    </div>
    <div class="tecs">
      <div class="tec1">
        <img class="tec-img"
             src="../assets/js1.png">
        <div class="tec-text">
          <h4 class="tec-title">数据搭建</h4>
          <div class="tec-context">
            专家知识、诊疗指南和临床路径、海量病历、文献数据
          </div>
        </div>
      </div>
      <div class="tec1">
        <img class="tec-img"
             src="../assets/js2.png">
        <div class="tec-text">
          <h4 class="tec-title">先进算法</h4>
          <div class="tec-context">
            基于自注意力机制的长距离依赖实体收取方法、基于强化学习和远程监督的关系抽取方法、基于注意力模型的诊断结果再排序方法
          </div>
        </div>
      </div>
      <div class="tec1">
        <img class="tec-img"
             src="../assets/js3.png">
        <div class="tec-text">
          <h4 class="tec-title">知识图谱</h4>
          <div class="tec-context">
            知识发展进程与结构关系的一系列各种不同的图形用可视化技术描述知识资源及其载体，挖掘、分析构建、绘制和显示知识及它们之间的相互关系
          </div>
        </div>
      </div>
      <div class="tec1">
        <img class="tec-img"
             src="../assets/js4.png">
        <div class="tec-text">
          <h4 class="tec-title">应用产品</h4>
          <div class="tec-context">
            全科临床决策支持系统（CDSS）、专科/单病种临床决策支持系统、eRWS病历结构化及科研辅助系统
          </div>
        </div>
      </div>
    </div>
    <div class="about"
         id="succ">
      <h3 class="ab-title">成功案例</h3>
      <div class="ab-text">自2019年初，我公司全科CDSS系统已经成功安装于全国十多家三级及二级医院。其中河北大学附属医院于2019年初引进我司CDSS系统，并于4月底完成与医院电子病历系统的对接和调试，投入全院使用。医院因此项应用获得了第二届全国智慧医疗大赛“互联网+医疗健康”临床辅助决策系统的最佳案例。</div>
    </div>
    <div class="hezuo"
         id="hezuo">
      <div class="line"></div>
      <div class="h-title">{{title1}}</div>
      <div class="line"></div>
    </div>
    <el-row :gutter="20">
      <el-col :span="8"
              v-for="(value, i) in data1"
              :key="i">
        <div class="ho-img">
          <img :src="`/static/hos/${value.img}`">
        </div>
      </el-col>

    </el-row>
    <div class="hezuo"
         style="margin-top: 40px;"
         id="hezuo">
      <div class="line"></div>
      <div class="h-title">{{title2}}</div>
      <div class="line"></div>
    </div>
    <el-row :gutter="20">
      <el-col :span="8"
              v-for="(value, i) in data2"
              :key="i">
        <div class="ho-img bg-img"
             :style="{ backgroundImage: 'url(' + '/static/hos/' + value.img + ')' }">
        </div>
      </el-col>

    </el-row>
    <div class="hezuo"
         style="margin-top: 40px;"
         id="hezuo">
      <div class="line"></div>
      <div class="h-title">数字医疗服务</div>
      <div class="line"></div>
    </div>
    <el-row :gutter="20">
      <el-col :span="24"
              v-for="(value, i) in data3"
              :key="i">
        <div class="hos3-img"
             :style="{ backgroundImage: 'url(' + '/static/hos/' + value.bg + ')' }">
          <div class="hos-3">
            <img class="hos3-item-img"
                 :src="`/static/hos/${value.img}`"
                 alt="">
            <div class="hos-name">{{ value.name }}</div>
          </div>
        </div>
      </el-col>
    </el-row>
    <!-- <el-row :gutter="20">
      <el-col :span="8">
        <div class="ho-img">
          <img src="../assets/hos_12.png">
        </div>
      </el-col>
      <el-col :span="8">
        <div class="ho-img">
          <img src="../assets/hos_11.png">
        </div>
      </el-col>
      <el-col :span="8">
        <div class="ho-img">
          <img src="../assets/hos_9.png">
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="8">
        <div class="ho-img">
          <img src="../assets/hos_14.png">
        </div>
      </el-col>
      <el-col :span="8">
        <div class="ho-img">
          <img src="../assets/hos_15.png">
        </div>
      </el-col>
    </el-row> -->

    <div class="hezuo"
         style="margin-top: 40px;"
         id="rongyu">
      <div class="line"></div>
      <div class="h-title">获得荣誉</div>

      <div class="line"></div>
    </div>
    <div class="rongyu">
      <div class="rongbac">
        <img src="../assets/z1.png">
      </div>
      <div class="rongbac">
        <img src="../assets/z2.jpg">
      </div>

    </div>
    <div class="marg"></div>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        data1: [],
        data2: [],
        data3: [],
        title1: '',
        title2: '',
      }
    },
    mounted () {
      this.data1 = window.hospitalList1
      this.data2 = window.hospitalList2
      this.data3 = window.hospitalList3
      this.title1 = window.hospitalList1Title
      this.title2 = window.hospitalList2Title
    },
  }
</script>
<style scoped>
  .containe {
    display: flex;
    flex-direction: column;
    color: #606266;
    /* text-align: center; */
    margin: 0.1rem 0;
  }
  .banner {
    display: flex;
    width: 100%;
    margin: 0.3rem 0 0.2rem 0;
  }
  .about {
    width: 100%;
    text-align: center;
    margin: 0.5rem 0 0.5rem 0;
  }
  .ab-title {
    margin-bottom: 0.3rem;
    font-size: 0.2rem;
    font-weight: 500;
  }
  .ab-text {
    font-size: 0.16rem;
    line-height: 0.3rem;
    text-indent: 2em;
    text-align: left;
  }
  .imgs {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    box-sizing: border-box;
  }
  .img {
    background: #fff;
    box-shadow: 0px 0px 40px 0px rgba(0, 0, 0, 0.1);
    width: 23%;
    text-align: center;
    padding: 0.2rem;
  }
  .img .icon {
    background: #1858c2;
    width: 0.5rem;
    height: 0.5rem;
    margin: auto auto;
    opacity: 0.9;
    border-radius: 50%;
    position: relative;
  }
  .icon .md-icon {
    width: 50%;
    margin: auto auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .img p {
    text-align: left;
    font-size: 0.14rem;
  }
  .bacimg {
    width: 100%;
    margin-top: 0.2rem;
  }
  .tecs {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .tec1 {
    width: 20%;
    background: #fff;
    box-shadow: 0px 0px 40px 0px rgba(0, 0, 0, 0.1);
    padding: 0.2rem;
    text-align: center;
  }
  .tec-img {
    width: 97%;
    /* border-radius: 0.08rem */
  }
  .tec-text {
    padding: 0.1rem 0;
  }
  .tec-title {
    font-size: 0.16rem;
    font-weight: 500;
  }
  .tec-context {
    font-size: 0.14rem;
    margin-top: 0.05rem;
    text-align: left;
  }
  .hezuo {
    font-size: 0.14rem;
    opacity: 0.9;
    display: flex;
    align-items: center;
    margin: 0.1rem auto;
  }
  .h-title {
    font-size: 0.18rem;
    font-weight: 500;
  }
  .line {
    width: 2.4rem;
    height: 1px;
    margin: 0 0.3rem 0 0.3rem;
    border-bottom: 1px dashed #e9e9e9;
  }
  .hosimg {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 0.1rem 0 0.3rem 0;
  }
  .caseimg {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin: 0.1rem 0 0.3rem 0;
  }
  .ho-img,
  .hos3-img {
    width: 100%;
    box-shadow: 0px 0px 40px 0px rgba(0, 0, 0, 0.1);
    margin: 0.2rem 0;
  }
  .ho-img {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 48px;
  }
  .ho-img img {
    width: 100%;
    max-width: 100%;
    height: auto;
  }
  .hos3-img {
    padding: 0.5rem 0.4rem;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    background-size: cover;
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center -22%;
  }
  .hos-3 {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  .hos3-item-img {
    width: 0.7rem;
    height: auto;
    margin-right: 20px;
    flex-shrink: 0;
  }
  .hos-name {
    flex: 1;
    text-align: left;
    font-size: 0.22rem;
  }

  .bg-img.ho-img {
    height: 0.7rem;
    background-size: cover;
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
  }
  /* .hosimg img{
                                                                                                                                                                                                                                                                                                                                                                            box-shadow: 0px 0px 40px 0px rgba(0,0,0,0.1);
                                                                                                                                                                                                                                                                                                                                                                            margin:0.2rem 0;
                                                                                                                                                                                                                                                                                                                                                                            width:28%;
                                                                                                                                                                                                                                                                                                                                                                        } */
  .rongyu {
    display: flex;
    justify-content: space-between;
  }
  .rongbac {
    background: #fff;
    width: 43%;
    height: auto;
    padding: 0.2rem;
    box-shadow: 0px 0px 40px 0px rgba(0, 0, 0, 0.1);
    text-align: center;
    margin-top: 0.2rem;
  }
  .rongbac img {
    width: 96%;
  }
  @media (max-width: 768px) {
    /*超小屏幕设备 手机*/
    .containe {
      padding: 0 0.4rem;
      margin: 0 auto;
    }
    .message {
      flex-direction: column;
      margin: 0 auto;
    }
    .er {
      margin: 0 auto;
      width: 40%;
      height: 40%;
    }
    .tec1 {
      width: 47%;
      margin-bottom: 0.3rem;
    }
    .line {
      width: 1rem;
    }
    .rongbac {
      width: 47%;
    }
    .img {
      width: 47%;
      padding: 0.3rem 0.2rem 0.3rem 0.2rem;
    }
    .hos3-img {
      background-position: center -90%;
    }
    /* .bg-img.ho-img {
                                                                              height: 54px;
                                                                            } */
  }

  @media (min-width: 768px) and (max-width: 992px) {
    /*小屏幕设备 平板*/
    .containe {
      padding: 0 0.4rem;
      margin: 0 auto;
    }
    .er {
      width: 30%;
      height: 30%;
      margin: 0;
    }
    .img {
      width: 23%;
      padding: 0.2rem 0.2rem 0.2rem 0.2rem;
    }
    .line {
      width: 1rem;
    }
    .tec1 {
      width: 23%;
      margin-bottom: 0.3rem;
    }
    .rongbac {
      width: 48%;
    }
    .ho-img {
      width: 100%;
    }
    .hos3-img {
      background-position: center -65%;
    }
  }

  @media (min-width: 992px) and (max-width: 1200px) {
    /*中等屏幕设备 桌面*/
    .containe {
      max-width: 1200px;
      padding: 0 0.8rem;
      margin: 0 auto;
    }
    .er {
      width: 30%;
      height: 30%;
    }
    .img {
      width: 23%;
      padding: 0.2rem 0.2rem 0.2rem 0.2rem;
    }
    .tec1 {
      width: 23%;
      margin-bottom: 0.3rem;
    }
    .rongbac {
      width: 48%;
    }
    .ho-img {
      width: 100%;
    }
    .hos3-img {
      background-position: center -40%;
    }
    .bg-img.ho-img {
      height: 0.9rem;
    }
  }

  @media (min-width: 1200px) {
    /*大屏幕设备 桌面*/
    .containe {
      max-width: 1200px;
      padding: 0 0.8rem;
      margin: 0 auto;
    }
    .er {
      width: 30%;
      height: 30%;
    }
    .img {
      width: 23%;
      padding: 0.3rem 0.2rem 0.3rem 0.2rem;
    }
    .tec1 {
      width: 23%;
      margin-bottom: 0.3rem;
    }
    .ho-img {
      /* width:30.5% */
    }
    .rongbac {
      width: 48%;
    }
    .bg-img.ho-img {
      height: 1.1rem;
    }
    .hos3-img {
      background-position: center -25%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Company.vue